import dynaForms from '@elab/core/utils/dynaForms';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import getTypes from './types';

const LOGIN_CHECKOUT = 'checkout-login';
const GUEST_CHECKOUT = 'checkout-guest';

const toggleFakeValidationsForRegistration = (state, { isLoyalty, forceReadOnly }) => {
    return {
        ...state,
        isLoyaltyPhone: isLoyalty,
        data: {
            ...state.data,
            uid: {
                ...state.data.uid,
                readOnly: forceReadOnly,
            },
            firstName: {
                ...state.data.firstName,
                readOnly: forceReadOnly,
            },
            communication: {
                ...state.data.communication,
                readOnly: forceReadOnly,
            },
            personalInfo: {
                ...state.data.personalInfo,
                readOnly: forceReadOnly,
            },
            lastName: {
                ...state.data.lastName,
                readOnly: forceReadOnly,
            },
            password: {
                ...state.data.password,
                readOnly: forceReadOnly,
            },
            mobileNumber: {
                ...state.data.mobileNumber,
                readOnly: forceReadOnly,
            },
        },
    };
};

const createReducer = storeName => {
    const dynaFormReduce = dynaForms.createReducer(storeName);
    const types = getTypes(storeName);

    return (
        state = {
            ...dynaInitialState(),
            formIsLoaded: false,
            customerLoyaltyStatus: null,
            isPinCodeOrDOBValid: true,
            isPinCodeAndDOBFilled: false,
        },
        action,
    ) => {
        state = dynaFormReduce(state, action);
        const options = state.data.checkoutOptions || {};
        switch (action.type) {
            case types.HIDE_GUEST_CHECKOUT:
                return {
                    ...state,
                    data: {
                        checkoutOptions: {
                            ...options,
                            values: options.values
                                ? options.values.filter(val => val.name !== GUEST_CHECKOUT)
                                : [],
                            value:
                                options.defaultValue === GUEST_CHECKOUT
                                    ? LOGIN_CHECKOUT
                                    : options.defaultValue,
                        },
                    },
                };
            case types.SET_FORM_IS_LOADED:
                return reduceAction(state, 'formIsLoaded', true);
            case types.SET_CUSTOMER_LOYALTY_STATUS:
                return {
                    ...state,
                    customerLoyaltyStatus: action.payload.status || null,
                };
            case types.SET_AUTH_OPTION:
                return {
                    ...state,
                    authOption: action.payload.option,
                };
            case types.SET_IS_PIN_CODE_OR_DOB_VALID:
                return {
                    ...state,
                    ...action.payload,
                };
            case types.SHOW_PINCODE:
                return {
                    ...state,
                    showPincode: action.payload,
                };
            case types.PHONE_DOB_RECEIVED:
                return toggleFakeValidationsForRegistration(state, action.payload);
            case types.SHOW_PINCODE:
                return {
                    ...state,
                    showPincode: action.payload,
                };
            case types.DISABLE_STEP1_BUTTON:
                return {
                    ...state,
                    ...action.payload,
                };
            default:
                return state;
        }
    };
};

export default createReducer;
